@let vsn = vision$ | async;

<div class="flex-container">
	<div class="left">
		{{ "trans_fee_trade" | translate }}
	</div>
	<div class="right">
		<span class="crossed-out">{{
			vsnFeeCollection()?.visionFeeDetail?.feeBefore
				| fiat_precision_symbol
					: {
							id: fiat()?.getId(),
							currencies: [fiat()],
							symbol: true
					  }
		}}</span>
		<span class="price">{{
			fee()
				| fiat_precision_symbol
					: {
							id: fiat()?.getId(),
							currencies: [fiat()],
							symbol: true
					  }
		}}</span>
	</div>
</div>

<div class="vsn-part">
	<!-- used -->
	<div class="flex-container">
		<div class="left">{{ "fee_transparency_details_vision_used" | translate: [vsn.getSymbol()] }}</div>
		<div class="right">{{
			vsnFeeCollection().visionFeeDetail?.visionAmount
				| tradable_precision_symbol: { id: vsn.getId(), ignorePrecision: true }
		}}</div>
	</div>
	<!-- price -->

	<div class="flex-container">
		<div class="left">{{ "fee_transparency_details_vision_price" | translate: [vsn.getSymbol()] }}</div>
		<div class="right"
			>{{ 1 | tradable_precision_symbol: { id: vsn.getId(), removePrecision: true } }} &asymp;
			{{
				vsnFeeCollection()?.visionFeeDetail?.visionRate
					| fiat_precision_symbol
						: {
								id: fiat()?.getId(),
								currencies: [fiat()],
								symbol: true,
								customPrecision: tradable()?.getPrecisionFiat()
						  }
			}}</div
		>
	</div>
</div>
